import React from 'react'

export default function Form({children}) {
  return (
    <div className="form">
        {children}
    </div>
  )
}
